<template>
  <div id="sidbarmenu">
    <v-navigation-drawer class="sidebar" v-model="drawer" permanent absolute width="242px">
      <v-toolbar flat class="transparent">
        <v-list class="pa-0">
          <div class="logo">
            <router-link to="/">
              <v-img :src="logo" class="homeLogo" max-width="180"  max-height="55"></v-img>
            </router-link>
          </div>
        </v-list>
        </v-toolbar>
        <span class="developpersection">{{userInfos.email}}</span>
        <v-list class="pt-0 listcontainer" dense>
          <v-list-tile  v-for="(link, i) in links" :key="i" v-on:click="redirectLink(link.to,link.router)" avatar class="v-list-item">
            <v-list-tile-action>
              <span :v-if="!link.isVueIcon" :class="isActiveRoute(link.to) ? `${link.iconClass} icon-enabled` : `${link.iconClass}  icon-disabled`"></span>
            </v-list-tile-action>
            <v-list-tile-title :class="isActiveRoute(link.to) ? 'sidebarlinkEnabled' : 'sidebarlinkDisabled'"   v-text="link.text" />
            </v-list-tile>
        </v-list>
        <br/>
        <br/>
        <br/>
        <div v-if="isDeveloperSectionVisible">
          <span class="developpersection">{{$t('InsuranceAPI.ApiKeys.DEVELOPERS_TITLE')}}</span>
          <v-list class="pt-0 " dense>
            <v-list-tile  v-for="(link, i) in developersLinks" :key="i" v-on:click="redirectLink(link.to,link.router)" avatar class="v-list-item">
              <v-list-tile-action>
                <span :class="activeLink === link.linkName ? `${link.iconClass} icon-enabled` : `${link.iconClass}  icon-disabled`"></span>
              </v-list-tile-action>
              <v-list-tile-title :class="activeLink === link.linkName ? 'sidebarlinkEnabled' : 'sidebarlinkDisabled'"   v-text="link.text" />
              </v-list-tile>
          </v-list>
        </div>
        <v-list class="pt-0 logoutsection" dense>
          <v-list-tile  key="logout" v-on:click="redirectLink('logout',true)" avatar class="v-list-item">
            <v-list-tile-action>
              <span class="icon-off icon-disabled"></span>
            </v-list-tile-action>
            <v-list-tile-title class="sidebarlinkDisabled" >{{$t('Login.SignIn.LOG_OUT_LINK')}}</v-list-tile-title>
            </v-list-tile>
        </v-list>
    </v-navigation-drawer>
  </div>

</template>

<script>
import { mapState } from 'vuex'
import auth from '@/services/Auth'
export default {
  data () {
    return {
      drawer: false,
      activeLink: 'home'
    }
  },
  watch: {
    '$route' (to, from) {
      this.activeLink = this.$router.currentRoute.name
    }
  },
  methods: {
    redirectLink (linkName, router) {
      if (router) {
        this.$store.dispatch('cover/setExtendedMode', true)
        this.$router.push({ name: linkName })
      } else {
        window.open(linkName, '_blank')
      }
    },
    isActiveRoute (routeName) {
      return routeName === this.$route.name
    },
    isMyAccountVisible () {
      const packagesToShowMyAccount = ['Claim', 'Coverage']
      var userPackagesToShowMyAccount = this.packages.find(function (pck) {
        return packagesToShowMyAccount.indexOf(pck.code) !== -1
      })
      return userPackagesToShowMyAccount
    }
  },
  computed: {
    ...mapState('siteconfig', ['config']),
    ...mapState('userdetails', ['userInfos', 'packages']),
    logo: function () {
      return this.config ? require(`@/assets/img/${this.config.imgFolder}/${process.env.VUE_APP_NODE_ENV_API}/Logo.svg`) : ''
    },
    links: function () {
      return [
        {
          to: 'myaccount',
          router: true,
          text: this.$t('InsuranceAPI.ShowUser.MY_ACCOUNT_LINK'),
          iconClass: 'icon-team',
          linkName: 'myaccount',
          isVisible: this.isMyAccountVisible()
        },
        {
          to: 'home',
          router: true,
          text: this.$t('Cover.ListCover.INVOICE_OVERVIEW_LINK'),
          iconClass: 'icon-cover',
          linkName: 'home',
          isVisible: true
        },
        {
          to: 'buyerclaims',
          router: true,
          text: this.$t('BuyerClaims.BuyerClaimsList.BUYER_CLAIMS_LINK'),
          iconClass: 'icon-claim',
          linkName: 'buyerclaims',
          isVisible: auth.hasBuyerClaimAccess()
        },
        {
          to: 'ice',
          router: true,
          text: this.$t('ICE.ListICE.LIST_ICE_LINK'),
          iconClass: 'icon-ice',
          linkName: 'ice',
          isVisible: auth.hasIceAccess()
        }
      ].filter(l => l.isVisible)
    },
    developersLinks: function () {
      return [
        {
          to: this.config.docUrl,
          router: false,
          text: this.$t('InsuranceAPI.ApiKeys.API_DOCUMENTATION_LINK'),
          iconClass: 'icon-cpu',
          linkName: 'docs',
          isVisible: true
        },
        {
          to: 'apikeys',
          router: true,
          text: this.$t('InsuranceAPI.ApiKeys.API_KEY_LINK'),
          iconClass: 'icon-key',
          linkName: 'apikeys',
          isVisible: true
        }
      ].filter(l => l.isVisible)
    },
    isDeveloperSectionVisible: function () {
      return this.userInfos ? this.userInfos.isDeveloper : false
    }
  }
}
</script>
<style>

#sidbarmenu .listitemlogo {
    height: 22px;
    width: 18px;
}

#sidbarmenu .v-list__tile__action .v-image__image {
    height: 22px;
    width: 18px;
}

#sidbarmenu .v-toolbar__content {
    height: 126px !important;
}

.sidebar {
    background-color:rgba(254, 255, 254, 1.0) !important;
    position: fixed;
}
#sidbarmenu .listitemlogo .v-image__image {
  margin-left: 24px;
}

.v-list-item{
  margin-top: 3px;
}

.sidebarlinkEnabled{
    color: var(--primary-color) !important;
}

.sidebarlinkDisabled{
    color: rgba(42, 42, 42, 1.0) !important;
}

.v-list-item:hover {
    background: #F5F5FE;
  }
.v-list-item:active {
    background: #F5F5FE;
  }
.listcontainer{
  margin-top: 54px;
}
</style>
